import axios from 'axios';
// Used Redux action to reset form data
import { resetForm } from 'components/wizard/container/actions';
import Container from 'components/wizard/container/container';
/* (Unused) Page Components:
 * Currently, the root / redirects to the registration wizard so these
 * links are not being used.
 */
import 'raf/polyfill';
import React, { Component } from 'react';
import { Provider as ReduxStore } from 'react-redux';
import {
  BrowserRouter as ReactRouter,
  Redirect,
  Route,
  withRouter
} from 'react-router-dom';
// Use Redux action to update URLs in head/footer, container ajax submission
import { updateSite } from 'redux/urlActions';
import { store } from './redux/configureStore';
import './theme/styles.scss';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

const EnhancedScrollToTop = withRouter(ScrollToTop);

// Reset Function resets form data, redirects to root of wizard
class Reset extends Component {
  componentDidMount() {
    store.dispatch(resetForm(undefined)); // Reset state
    updateUrls(1000); // Try updating URLs
  }

  render() {
    return (
      // Return to root after performing reset operations
      <Redirect to="/register/wizard/1" />
    );
  }
}
// Try to fetch URLs from config.js
// This file is served in the public folder, but may be modified
// outside of this app; mechanism here is to make sure this file gets re-read.
const updateUrls = async delay => {
  setTimeout(() => {
    if (window.environmentConfig) {
      store.dispatch(
        updateSite({
          mainSiteUrl: window.environmentConfig.MAIN_SITE_URL
        })
      );
      store.dispatch(
        updateSite({
          btisApiUrl: window.environmentConfig.BTIS_API_URL
        })
      );
      store.dispatch(
        updateSite({
          niprApiUrl: window.environmentConfig.NIPR_API_URL
        })
      );
      return true;
    } else {
      return false;
    }
  }, delay); // Try to get config after a delay
};

class App extends Component {
  componentDidMount() {
    // Try to fetch URLs from config.js
    // This file is served in the public folder, but may be modified
    // outside of this app; mechanism here is to make sure this file gets re-read.
    updateUrls(1000); // Read in config from window; 1000ms delay
  }

  render() {
    let source = (new URL(window.location.href)).searchParams.get('source');
    if (source) {
      store.dispatch(updateSite({ source }));
      const visited = sessionStorage.getItem("setRequestSource");
      if (!visited) {
        const
          requestUrl = window.environmentConfig.BTIS_BASE_API_URL.replace(/^https?:/, '') +
            'Common/v1/audittrail/audit_trail',
          requestBody = {
            "DoneBY": "",
            "Event": "Landed on Producer Registration from " + source,
            "LOB": "Producer Registration"
          },
          requestConfig = {
            headers: {
              'Content-Type': 'application/json',
              'charset': 'UTF-8'
            }
          };

        axios.post(requestUrl, requestBody, requestConfig)
          .then(() => sessionStorage.setItem("setRequestSource", true));

      }
    }

    const affiliate = (new URL(window.location.href))
      .searchParams.get('affiliate');
    if (affiliate) {
      sessionStorage.setItem("affiliate", affiliate);
    }


    const
      params = (new URL(window.location.href))
        .searchParams.entries(),
      newParams = new URLSearchParams();
    for (const [name, value] of params) {
      newParams.append(name.toLowerCase(), value);
    }

    const state = newParams.get('state');
    if (state) {
      sessionStorage.setItem("state", state);
    }

    const license = newParams.get('license');
    if (license) {
      sessionStorage.setItem("license", license);
    }

    const fein = newParams.get('fein');
    if (fein) {
      sessionStorage.setItem("fein", fein);
    }


    return (
      <div className="App">
        <ReduxStore store={store}>
          <ReactRouter>
            <EnhancedScrollToTop>
              <main className="content">
                <Redirect exact path="/register/wizard/0" to="/reset" />
                <Route
                  path="/register/wizard/:step"
                  exact
                  component={Container}
                />

                {/* Path to reset forms; this component in turn redirects back to root */}
                <Route path="/reset" component={Reset} />

                {/* Root path goes to first step of the wizard */}
                <Redirect exact path="/" to="/register/wizard/1" />
              </main>
            </EnhancedScrollToTop>
          </ReactRouter>
        </ReduxStore>
      </div>
    );
  }
}

export default App;
